/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var SummaryCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryCell, _super);
    function SummaryCell(a) {
        var _this = _super.call(this, a) || this;
        _this.b3 = null;
        _this.b4 = null;
        _this.b5 = null;
        _this.b9 = -1;
        _this.b8 = -1;
        _this.z.setRawStyleProperty("vertical-align", "middle");
        _this.b5 = a.createElement("div");
        _this.b3 = a.createElement("span");
        _this.b3.setRawStyleProperty("display", "inline-block");
        _this.b3.setRawStyleProperty("width", "40%");
        _this.b3.setRawStyleProperty("white-space", "nowrap");
        _this.b3.setRawStyleProperty("text-overflow", "ellipsis");
        _this.b3.setRawStyleProperty("vertical-align", "middle");
        _this.b3.setRawStyleProperty("overflow", "hidden");
        _this.b5.append(_this.b3);
        _this.b4 = a.createElement("span");
        _this.b4.setRawStyleProperty("display", "inline-block");
        _this.b4.setRawStyleProperty("width", "60%");
        _this.b4.setRawStyleProperty("text-align", "right");
        _this.b4.setRawStyleProperty("white-space", "nowrap");
        _this.b4.setRawStyleProperty("text-overflow", "ellipsis");
        _this.b4.setRawStyleProperty("vertical-align", "middle");
        _this.b4.setRawStyleProperty("overflow", "hidden");
        _this.b5.append(_this.b4);
        _this.z.append(_this.b5);
        return _this;
    }
    Object.defineProperty(SummaryCell.prototype, "b6", {
        get: function () {
            return this.b3;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryCell.prototype, "b7", {
        get: function () {
            return this.b4;
        },
        enumerable: true,
        configurable: true
    });
    SummaryCell.prototype.bs = function (a, b) {
        _super.prototype.bs.call(this, a, b);
        var c = Math.max(0, a - b);
        if (this.b9 != c) {
            this.b9 = c;
        }
    };
    SummaryCell.prototype.bm = function (a, b) {
        _super.prototype.bm.call(this, a, b);
        var c = Math.max(0, a - b);
        if (this.b8 != c) {
            this.b8 = c;
        }
    };
    SummaryCell.prototype.get_r = function () {
        return false;
    };
    SummaryCell.prototype.bd = function (a, b, c) {
        _super.prototype.bd.call(this, a, b, c);
        if (a == "Indent" || a == "IsCollapsable") {
            this.b5.setRawStyleProperty("margin-left", this.au + this.aw + this.av + "px");
        }
    };
    SummaryCell.$t = markType(SummaryCell, 'SummaryCell', GridCellBase.$);
    return SummaryCell;
}(GridCellBase));
export { SummaryCell };
//# sourceMappingURL=SummaryCell.js.map
